import ReactSelect from 'react-select';
import ReactSelectAsync from 'react-select/async';
import ReactSelectAsyncCreatable from 'react-select/async-creatable';
import ReactSelectCreatable from 'react-select/creatable';
export const getReactSelectComponent = ({ async = false, creatable = false, }) => {
    if (async && !creatable) {
        return ReactSelectAsync;
    }
    if (async && creatable) {
        return ReactSelectAsyncCreatable;
    }
    if (!async && creatable) {
        return ReactSelectCreatable;
    }
    return ReactSelect;
};
//# sourceMappingURL=getReactSelectComponent.js.map